import BackendApiClient from './BackendApiClient';
import { DataWrappedResponse } from '../exports/Types';
import { PromoCodeData } from '../../store/api-slices';

class CompanyManager {
  public async getPromoCodeDetails(companyId: number, code: string): Promise<DataWrappedResponse<PromoCodeData>> {
    return BackendApiClient.request({
      method: 'GET',
      url: `/companies/${companyId}/promo-codes/${encodeURIComponent(code)}`,
    });
  }
}

export default new CompanyManager();
